import { Icon } from '@yuno/design-system-web'
import {
  ManageYourAccountsLink,
  ManageYourAccountsLinkContainer,
} from './account-menu.styled'

export type ManageAccountMenuItemProps = {
  label: string
  onClick: () => void
}

export const ManageAccountMenuItem = ({
  label,
  onClick,
}: ManageAccountMenuItemProps) => (
  <ManageYourAccountsLinkContainer onClick={onClick}>
    <ManageYourAccountsLink>{label}</ManageYourAccountsLink>
    <Icon name="CaretRight" size="12" />
  </ManageYourAccountsLinkContainer>
)
